{ "columns":0,
 "grid":
    {
     "height":1,
     "orientation":"orthogonal",
     "width":1
    },
 "margin":0,
 "name":"tileset",
 "spacing":0,
 "tilecount":8,
 "tiledversion":"1.8.6",
 "tileheight":32,
 "tiles":[
        {
         "id":0,
         "image":"tiles\/2.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":1,
         "image":"tiles\/1.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":2,
         "image":"tiles\/3.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":3,
         "image":"tiles\/4.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":4,
         "image":"tiles\/5.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":5,
         "image":"tiles\/7.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":6,
         "image":"tiles\/8.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":7,
         "image":"tiles\/9.png",
         "imageheight":32,
         "imagewidth":32
        }],
 "tilewidth":32,
 "type":"tileset",
 "version":"1.8"
}